import { useCallback } from "react";
import { useSearchParams } from "react-router";
import { pageSearchParamKey, parsePageParam, writePageParam } from "@/utils";

export type PageParamControls = {
  page: number;
  setPage: (page: number) => void;
};

// 목록 page를 URL `?page=`와 양방향으로 동기화한다. 변경은 replace로 기록해 브라우저 기록을
// 늘리지 않는다. 상세로 진입(push)한 뒤 뒤로가기를 하면 같은 page로 돌아온다.
// 클래스 컴포넌트(PageBase)는 훅을 쓸 수 없다. 그래서 함수형 래퍼가 page/setPage를 props로 주입한다.
export function usePageParam(key: string = pageSearchParamKey): PageParamControls {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parsePageParam(searchParams.get(key));
  const setPage = useCallback(
    (nextPage: number) => {
      setSearchParams((prev) => writePageParam(prev, nextPage, key), { replace: true });
    },
    [key, setSearchParams],
  );
  return { page, setPage };
}
